import DocumentTitle from "./document-title";

export default DocumentTitle;
